<template>
  <EDialog
    :center-dialog-visible="agreeVisible"
    dialog-type="other"
    :popup-width="'820px'"
    :dialog-title="'绿色低碳信息提供告知同意书'"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <div>
      <div>尊敬的平台用户：</div>
      <div class="content">
        <div class="textIndent-28">
          <span class="font-bold">您向平台运营方易派客电子商务有限公司</span
          >（住所：北京市朝阳区朝阳门北大街22号1幢6层628室，电话：95388转5）提供<span
            class="font-bold"
            >您的产品碳足迹认证证书、产品碳足迹评价报告、绿色工厂评价、绿色供应链评价、中国绿色产品认证</span
          >等相关信息，<span class="font-bold"
            >将用于以下用途：1.价值链温室气体排放核算：用于中国石油化工股份有限公司范围三温室气体排放核算，完善中石化价值链碳排放管理。2.绿色采购评价：相关信息中的数据可能作为中石化未来绿色采购工作的参考依据，用于绿色供应商、绿色产品等评价体系的构建与优化。3.绿色采购供应链平台建设：在未来绿色采购供应链平台建设中，相关信息可能通过脱敏方式展示，并用于绿色产品打标等平台功能。</span
          >
        </div>
        <div class="textIndent-28">
          您提供的绿色低碳相关数据及评价认证将由易派客平台及中国石油化工股份有限公司严格按照相关法律法规及内部管理制度进行保密处理，确保您的数据得到合理保护，并避免未经授权的访问、泄露或滥用。
        </div>
        <div class="textIndent-28">
          勾选同意后，即确认您已阅读并完全理解以上条款，承诺所提供信息的真实、完整、准确，并自愿授权易派客平台及中国石油化工股份有限公司在本文载明的用途范围内合规使用您提交的绿色低碳相关数据及评价认证。如有任何关于数据使用的问题，您可以随时联系我们的客户服务团队，我们将为您提供进一步的帮助。未来平台如对以上条款有任何变更，会通过平台公告等方式通知您，您如对变更后的条款有异议，可邮件反馈至易派客客服邮箱，双方协商解决。
        </div>
      </div>

      <div class="time">易派客电子商务有限公司</div>
      <div class="time">2025年12月05日</div>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';

export default {
  components: {
    EDialog,
  },
  props: {
    agreeVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    resetPopupData() {
      this.$emit('change');
    },
    submitPopupData() {
      this.$emit('change');
    },
  },
};
</script>

<style lang="scss" scoped>
.time {
  text-align: right;
}
.textIndent-28 {
  text-indent: 28px;
}
.font-bold {
  font-weight: bold;
}
</style>
